module.exports = __webpack_public_path__ + "static/media/del-dark.6e616470.svg";